import React, { Component } from 'react';
import axios from 'axios';
import { API_HOST, getTenant } from '../../consts';
import StackedAreaChart from '../../components/StackedAreaChart';
import ParticipacaoDreColumn from '../../components/ParticipacaoDreColumn';
import HeaderAvalia from '../../components/HeaderAvalia';
import { get } from 'lodash';
import { Nav, NavItem } from 'reactstrap';
import { ThemeContext } from '../../contexts/ThemeContext';
import Logo from '../../assets/images/logos/Logos';
import PlurallLogo from '../../assets/images/logos/Plurall_logo.png';
import AvaliaLogo from '../../assets/images/logos/avalia-logo.png';
import { GeneralStudentStyleButton } from './style';

const ambiente =
  getTenant() === 'plurall'
    ? { pricolor: 'rgb(103, 53, 221)', logo: PlurallLogo }
    : { pricolor: '#3C4583', logo: AvaliaLogo };

class StudentAnalysis extends Component {
  state = {
    loading: false,
    boletimData: {}
  };

  componentDidMount() {
    this.fetchBoletimData();
  }
  componentWillUnmount() {
    this.state.loading = true;
  }

  fetchBoletimData = () => {
    const avaliaPk = this.props.match.params.id;

    axios
      .get(`${API_HOST}/avalia/boletim_mt/${avaliaPk}`)
      .then((res) => {
        this.setState({ boletimData: res.data, loading: true });
      })
      .catch((err) => console.error(err));
  };

  render() {
    const { boletimData, loading } = this.state;
    return (
      <>
        <div className="container">
          <div className="row header-row">
            <div className="col-sm-6 col-md-6">
              <div className="col-sm-6 col-md-6">
                <Nav className="nav-logos">
                  <NavItem>
                    <figure>
                      <ThemeContext.Consumer>
                        {(theme) => (
                          <img
                            className={
                              Logo.client ? 'logo-client' : 'logo-main'
                            }
                            src={ambiente.logo}
                            height="70"
                          />
                        )}
                      </ThemeContext.Consumer>
                    </figure>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </div>
        </div>
        <div
          id="nav-expand"
          className="nav-expand"
          style={{ background: `${ambiente.pricolor}` }}
        >
          <Nav
            className="navbar-links"
            style={{ background: `${ambiente.pricolor}`, border: 'none' }}
          />
        </div>
        <div style={{ marginTop: '5rem', background: '#fff' }}>
          <GeneralStudentStyleButton>
            <div className="container mb-4 pb-4">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h1>Diagnóstico do Estudante</h1>
                      <hr />
                    </div>
                    <div
                      className="card-body"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                      }}
                    >
                      <HeaderAvalia
                        schoolName={get(boletimData, 'NM_ESCOLA')}
                        schoolYear={get(boletimData, 'NM_ETAPA', '')}
                        dreAndMunicipio={get(boletimData, 'NM_DRE')}
                        student={get(boletimData, 'NM_ALUNO', '')}
                      />
                      {loading && boletimData(
                        <StackedAreaChart
                          dataDot={boletimData}
                          pontos={true}
                          useBase={true}
                        />
                      )}
                      <ParticipacaoDreColumn boletimaluno={boletimData} />
                    </div>
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'right',
                        marginBottom: '1rem',
                        marginLeft: '-1rem'
                      }}
                    >
                      <button
                        className='button-primary'
                        style={{
                          // color: 'white',
                          // backgroundColor: 'rgb(103, 53, 221)',
                          border: '1px solid rgba(58, 58, 58, 0.25)',
                          fontSize: '12pt',
                          textAlign: 'center',
                          cursor: 'pointer',
                          borderRadius: '8px',
                          boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                          letterSpacing: '1px',
                          padding: '4px 16px',
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                        onClick={() =>
                          window.open(
                            `/aluno-acertos/${this.props.match.params.id}`,
                            '_self'
                          )
                        }
                      >
                        Relatório de Habilidade
                      </button>Estudante
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </GeneralStudentStyleButton>
        </div>

        <div
          style={{
            backgroundColor: `${ambiente.pricolor}`,
            color: '#fff',
            fontSize: 15,
            fontWeight: 400,
            padding: '35px 0 0px 0'
          }}
        ></div>
      </>
    );
  }
}

export default StudentAnalysis;
